import React, { Component } from "react";
import ColorBox from "./ColorBox";
import Navbar from "./Navbar";
import GlobalNav from "./components/GlobalNav";
import { withStyles } from '@material-ui/styles';
import styles from './styles/PaletteStyles';
import PaletteFooter from './PaletteFooter';
import ColorSelectionManager from './ColorSelectionManager';
import { ColorSelectionContext } from './contexts/ColorSelectionContext';
import MetaTags from './components/MetaTags';
import StarsIcon from '@material-ui/icons/Stars';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { generateAIVariation } from './helpers/aiHelpers';

class Palette extends Component {
  static contextType = ColorSelectionContext;
  
  constructor(props) {
    super(props);
    this.state = {
      level: 500,
      format: "hex",
      anchorEl: null,
      aiColors: [],
      showAIVariations: false,
    };
    this.paletteRef = React.createRef();
    this.changeLevel = this.changeLevel.bind(this);
    this.changeFormat = this.changeFormat.bind(this);
    this.handleSelectColor = this.handleSelectColor.bind(this);
    this.handleAIMenuOpen = this.handleAIMenuOpen.bind(this);
    this.handleAIMenuClose = this.handleAIMenuClose.bind(this);
    this.applyAIVariation = this.applyAIVariation.bind(this);
  }
  
  changeLevel(level) {
    this.setState({ level });
  }
  
  changeFormat(val) {
    this.setState({ format: val });
  }
  
  handleSelectColor(color, isSelected) {
    this.context.toggleColor(color, isSelected);
  }

  handleAIMenuOpen(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleAIMenuClose() {
    this.setState({ anchorEl: null });
  }

  applyAIVariation(type) {
    const { colors } = this.props.palette;
    const { level, format } = this.state;
    // Use the first color of current level as seed
    const seedColor = colors[level][0][format];
    const aiColors = generateAIVariation(seedColor, type);
    this.setState({
      aiColors,
      showAIVariations: true,
      anchorEl: null
    });
  }
  
  render() {
    const { colors, paletteName, emoji, id } = this.props.palette;
    const { classes } = this.props;
    const { level, format, anchorEl, aiColors, showAIVariations } = this.state;
    const { selectedColors, removeColorByIndex, clearColors, isColorSelected } = this.context;
    
    const displayColors = showAIVariations ? aiColors : colors[level];

    const colorBoxes = displayColors.map((color, i) => {
      const background = showAIVariations ? color.color : color[format];
      const name = showAIVariations ? color.name : color.name;
      const selected = isColorSelected(background);
      return (
        <ColorBox 
          key={showAIVariations ? `ai-${i}` : color.id}
          background={background}
          name={name}
          id={showAIVariations ? `ai-${i}` : color.id}
          paletteId={id}
          showLink={true}
          showingFullColorPalette={true}
          onSelectColor={this.handleSelectColor}
          isSelected={selected}
        />
      );
    });
    
    return (
      <>
        <MetaTags
          title={`${paletteName} - Color Palette`}
          description={`Explore the ${paletteName} color palette with ${colors[level].length} shades. View color codes, test accessibility, and export in multiple formats.`}
          keywords={`${paletteName}, color palette, ${colors[level].map(c => c.name).join(', ')}, color scheme, design colors`}
          url={window.location.href}
        />
        <div className={classes.Palette} ref={this.paletteRef}>
          <GlobalNav />
          <Navbar
            hideBrand
            showSlider={true}
            level={level}
            changeLevel={this.changeLevel}
            handleChange={this.changeFormat}
            palette={this.props.palette}
            paletteElement={this.paletteRef.current}
          />
        <div style={{ position: 'absolute', top: '75px', right: '20px', zIndex: 90 }}>
          <Tooltip title="AI Magic Variations" placement="left" arrow>
            <IconButton
              onClick={this.handleAIMenuOpen}
              style={{ backgroundColor: '#764ba2', color: 'white', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' }}
            >
              <StarsIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={this.handleAIMenuClose}
          >
            <MenuItem onClick={() => this.applyAIVariation('analogous')}>AI Analogous</MenuItem>
            <MenuItem onClick={() => this.applyAIVariation('triadic')}>AI Triadic</MenuItem>
            <MenuItem onClick={() => this.applyAIVariation('monochrome')}>AI Monochrome</MenuItem>
            <MenuItem onClick={() => this.applyAIVariation('complementary')}>AI Complementary</MenuItem>
            {showAIVariations && (
              <MenuItem onClick={() => this.setState({ showAIVariations: false })}>Reset to Original</MenuItem>
            )}
          </Menu>
        </div>
          <div className={classes.colors}>
            {colorBoxes}
          </div>
          <PaletteFooter paletteName={paletteName} emoji={emoji} colors={colors[level]} />
          
          {/* Color Selection Manager */}
          {selectedColors.length > 0 && (
            <ColorSelectionManager
              selectedColors={selectedColors}
              onRemoveColor={removeColorByIndex}
              onClearAll={clearColors}
              paletteName={paletteName}
            />
          )}
        </div>
      </>
    );
  }
}

export default withStyles(styles)(Palette);
